import { useEffect, useState } from "react";
import styles from "./HeroSlider.module.scss";

export default function HeroSlider({
  label = "Warszawski Klub Hokeja",
  images = [],
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (images.length <= 1) {
      return undefined;
    }

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className={styles.slider}>
      {images.map((src, index) => (
        <div
          key={src}
          className={`${styles.slide} ${
            index === currentIndex ? styles.active : ""
          }`}
          style={{ backgroundImage: `url(${src})` }}
          aria-hidden={index !== currentIndex}
        />
      ))}

      <div className={styles.label}>
        <span className={styles.kicker}>Warsaw Hockey Club</span>
        <h3>{label}</h3>
      </div>
    </div>
  );
}
